import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { FeatureContextService } from "@/_services/feature-context.service";

@Component({
    selector: "app-root",
    encapsulation: ViewEncapsulation.None,
    styleUrls: ["app.component.scss", "../assets/css/core.scss"],
    templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
    title = "Preflight";

    constructor(
        private router: Router,
        // Injected to force eager initialization so context is set on first load
        _featureContext: FeatureContextService,
    ) {}

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (document.scrollingElement) {
                    document.scrollingElement.scrollTop = 0;
                }
            }
        });
    }
}
